import Axios from 'axios'
// import { queryParameters } from './queryParameters'
// import { ENVIRONMENT }     from '../config'

export async function doLogging ( event ) {

  // const params = queryParameters();

  const endpoint = 'https://concernapp.dbmi.columbia.edu/logging_api/userEvent';
  // const endpoint = `https://${ENVIRONMENT}.partners.org/api/Logging`;
  
  const payload = {
    "patient_fhir_id": event.patientFhirID || 'not yet retrieved',
    "encounter_fhir_id": event.encounterFhirID || 'not yet retrieved',
    "user_fhir_id": event.userFhirID || 'not yet retrieved',
    "event_type": event.eventType,
    "event_detail": event.eventDetails
  };

  // const payload = {
  //   encounter_id: params.encounterid,
  //   userID: params.userepicid,
  //   eventType: event.eventType,
  //   eventDetail: event.eventDetails,
  // };

  await Axios.post( endpoint, payload );
}